import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 bg-dark-bg flex flex-col items-center justify-center z-[100]">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="relative"
            >
                <div className="absolute inset-0 bg-red-500/20 blur-3xl rounded-full" />
                <img
                    src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/693abcae586ea1ac8122ea70/21aa16bfb_CORE829LARGEPXlogonolettersnobg.png"
                    alt="Core829"
                    className="h-24 w-auto relative z-10"
                />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="mt-8 text-center"
            >
                <h2 className="text-2xl font-bold text-white mb-2 tracking-wider">CORE829</h2>
                <div className="flex items-center gap-1 justify-center">
                    <motion.div
                        animate={{ height: [4, 16, 4] }}
                        transition={{ repeat: Infinity, duration: 1, ease: "easeInOut", delay: 0 }}
                        className="w-1 bg-red-500 rounded-full"
                    />
                    <motion.div
                        animate={{ height: [4, 16, 4] }}
                        transition={{ repeat: Infinity, duration: 1, ease: "easeInOut", delay: 0.2 }}
                        className="w-1 bg-red-500 rounded-full"
                    />
                    <motion.div
                        animate={{ height: [4, 16, 4] }}
                        transition={{ repeat: Infinity, duration: 1, ease: "easeInOut", delay: 0.4 }}
                        className="w-1 bg-red-500 rounded-full"
                    />
                </div>
            </motion.div>
        </div>
    );
};

export default LoadingScreen;
